import Button from '@insided/control/uikit/Button'
/* eslint-disable import/no-internal-modules */
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@insided/deprecated-preact-components/design-system-components/modal'

interface EmptyTrashModalProps {
  onEmptyTrash: () => Promise<any>
  onClose: () => void
}

const EmptyTrashModal = ({ onEmptyTrash, onClose }: EmptyTrashModalProps) => {
  const bodyText = 'Are you sure you want to permanently delete the items in the trash can? You can’t undo this action.'
  return (
    <Modal variant='M' onClose={onClose} isControl>
      <ModalHeader title='Empty Trash' />
      <ModalBody>
        <div className='empty-trash-modal'>
          <p>{bodyText}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          title='Empty Trash'
          onClick={onEmptyTrash}
          size='medium'
          variant='warning'
          data-qa='empty-trash'
        />
        <Button title='Cancel' onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default EmptyTrashModal
